"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOAuth = void 0;
const tslib_1 = require("tslib");
const common_components_1 = require("@as-react/common-components");
const OAuthUtil_1 = require("../util/OAuthUtil");
const OAUTH_REFERER = 'oauth_referer';
const OAUTH_VERIFIER = 'oauth_verifier';
const useOAuth = () => {
    const { servicesEndpoint, defaultRequestParams, rootWithLanguageSuffix, oauth } = (0, common_components_1.useAemConfig)();
    const { clientId } = oauth;
    const initiateAuth = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const pkce = yield (0, OAuthUtil_1.generatePKCEChallange)();
        const redirectUri = `${window.location.origin}${rootWithLanguageSuffix}/auth.html`;
        window.sessionStorage.setItem(OAUTH_REFERER, window.location.href);
        window.sessionStorage.setItem(OAUTH_VERIFIER, JSON.stringify(pkce.code_verifier));
        const baseUrl = servicesEndpoint.startsWith('http')
            ? servicesEndpoint
            : `${window.location.origin}${servicesEndpoint}`;
        const url = new URL(`${baseUrl}authorization-server/oauth2/authorize`);
        const params = new URLSearchParams(url.search);
        params.append('response_type', 'code');
        params.append('client_id', clientId);
        params.append('scope', 'openid profile');
        params.append('redirect_uri', redirectUri);
        params.append('code_challenge', pkce.code_challenge);
        params.append('code_challenge_method', 'S256');
        for (const [key, value] of Object.entries(defaultRequestParams)) {
            if (value !== undefined && value !== null) {
                params.append(key, value.toString());
            }
        }
        url.search = params.toString();
        window.location.href = url.toString();
    });
    return {
        initiateAuth,
    };
};
exports.useOAuth = useOAuth;
